// An athlete tile's photo: the small server-made thumbnail, falling back once to
// the full photo if the thumbnail is missing (photos uploaded before thumbnails
// existed, or a thumbnail that failed to save). Used by the partner home tiles
// and the staff Concierge board.
import React, { useEffect, useState } from 'react';

export default function TilePhoto({ thumb, full, className, alt = '', ...rest }) {
  const [src, setSrc] = useState(thumb || full);
  // A tile stays mounted (keyed by athlete) when its data reloads, so a new photo must reset the fallback.
  useEffect(() => { setSrc(thumb || full); }, [thumb, full]);
  const onError = () => { if (full && src !== full) setSrc(full); };
  return <img className={className} src={src} alt={alt} onError={onError} {...rest} />;
}
